import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M22.67 17.07C22.3545 17.0687 22.0496 16.9553 21.81 16.75V16.75L19.05 14.46H12.83C10.9175 14.4681 9.07926 13.7201 7.7157 12.379C6.35214 11.0379 5.57373 9.21239 5.55 7.3C5.56954 5.38656 6.31682 3.55233 7.64 2.17C8.31132 1.4872 9.11108 0.943954 9.99323 0.571531C10.8754 0.199107 11.8225 0.00486889 12.78 0L16.61 0C18.5287 0.0116318 20.3686 0.764044 21.7457 2.10011C23.1227 3.43617 23.9304 5.25258 24 7.17V15.74C24 16.0927 23.8599 16.431 23.6105 16.6805C23.361 16.9299 23.0227 17.07 22.67 17.07ZM22.45 16C22.5036 16.0349 22.5661 16.0534 22.63 16.0534C22.6939 16.0534 22.7564 16.0349 22.81 16C22.8678 15.9743 22.9166 15.9322 22.9504 15.8788C22.9842 15.8254 23.0015 15.7632 23 15.7V7.17C22.936 5.52476 22.2423 3.96699 21.0624 2.81867C19.8824 1.67035 18.3064 1.01927 16.66 1H12.78C11.9463 1.02559 11.1259 1.21542 10.3657 1.55861C9.60555 1.90181 8.92056 2.39162 8.35 3C7.77342 3.5651 7.31681 4.24075 7.00752 4.98648C6.69823 5.73222 6.54262 6.5327 6.55 7.34C6.5565 8.16109 6.7255 8.97277 7.04727 9.72821C7.36903 10.4837 7.83719 11.1679 8.42474 11.7415C9.01228 12.3151 9.70759 12.7667 10.4705 13.0702C11.2335 13.3738 12.049 13.5232 12.87 13.51H19.41L22.45 16Z"
        fill="currentColor"
      />
      <path
        d="M11.9923 7.52271C11.9943 6.98148 11.5573 6.54103 11.016 6.53896C10.4748 6.53688 10.0343 6.97395 10.0323 7.51518C10.0302 8.05642 10.4673 8.49686 11.0085 8.49894C11.5497 8.50102 11.9902 8.06395 11.9923 7.52271Z"
        fill="currentColor"
      />
      <path
        d="M15.9976 7.50268C15.9997 6.96144 15.5626 6.521 15.0214 6.51892C14.4801 6.51684 14.0397 6.95392 14.0376 7.49515C14.0355 8.03639 14.4726 8.47683 15.0139 8.47891C15.5551 8.48098 15.9955 8.04391 15.9976 7.50268Z"
        fill="currentColor"
      />
      <path
        d="M20.003 7.47262C20.005 6.93138 19.568 6.49094 19.0267 6.48886C18.4855 6.48678 18.0451 6.92386 18.043 7.46509C18.0409 8.00633 18.478 8.44677 19.0192 8.44885C19.5604 8.45092 20.0009 8.01385 20.003 7.47262Z"
        fill="currentColor"
      />
      <path
        d="M17.34 15.43C17.0354 16.8331 16.2586 18.0892 15.1392 18.9883C14.0198 19.8875 12.6258 20.3752 11.19 20.37H4.61L1.56 22.9C1.51509 22.9522 1.45452 22.9886 1.38729 23.0037C1.32006 23.0188 1.24977 23.0117 1.18686 22.9836C1.12394 22.9555 1.07178 22.9079 1.03811 22.8478C1.00444 22.7877 0.991077 22.7183 0.999997 22.65V14.09C1.01513 12.9156 1.36461 11.7698 2.0075 10.7869C2.6504 9.80391 3.56009 9.02453 4.63 8.54V7.45L4.44 7.52C3.13957 8.06241 2.02627 8.97348 1.23732 10.1409C0.448374 11.3083 0.0182611 12.6811 -2.51978e-06 14.09V22.65C-0.00534071 22.9039 0.063788 23.1537 0.198849 23.3688C0.333909 23.5838 0.528987 23.7546 0.759997 23.86C0.939664 23.939 1.13375 23.9798 1.33 23.98C1.64444 23.9824 1.94941 23.8725 2.19 23.67L5 21.37H11.22C12.9196 21.373 14.5665 20.7804 15.8745 19.6952C17.1826 18.61 18.0691 17.1009 18.38 15.43H17.34Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);
